import ICloudCredentialPromptDialog from '../components/iCloudCredentialPromptDialog';
import { showModal } from 'owa-modal';
import { default as hello, HelloJSLoginOptions } from 'hellojs';
import initalizeIdp from './initalizeIdp';
import { OAuthProviderType } from '../contracts/SharedProperties';

interface LoginOptions extends HelloJSLoginOptions {
    clientId: string;
}

type ICloudCredentialPromptDialogResult = {
    userName: string;
    password: string;
};

export type LoginConfig = { [provider: string]: LoginOptions };

export default function loginToIdp(provider: OAuthProviderType, options?: LoginOptions) {
    if (provider == OAuthProviderType.ICloud) {
        // get the email address and passcode from dialog
        return openICloudCredentialPromptDialog().then(result => {
            if (result) {
                return {
                    authResponse: {
                        emailAddress: result.userName,
                        passPhrase: result.password,
                        providerType: provider,
                    },
                };
            } else {
                return null;
            }
        });
    } else {
        initalizeIdp(provider, options.clientId);
        return hello.login(provider.toString(), options);
    }
}

function openICloudCredentialPromptDialog(): Promise<
    ICloudCredentialPromptDialogResult | undefined
> {
    const [modalPromise] = showModal<ICloudCredentialPromptDialogResult>(
        ICloudCredentialPromptDialog
    );
    return modalPromise.then(response => {
        if (response.userName && response.password) {
            return { userName: response.userName, password: response.password };
        } else {
            return undefined;
        }
    });
}
